<template>
  <div class="signin-page">
    <div class="left-side vertical-center pc-mode">
      <div class="container-fluid" align="left">
        <img
          src="@/assets/static_content/logo-solid-white.svg"
          style="width:27.8rem; cursor:pointer"
          @click="goToLanding"
        />
        <div class="horizontal-line" style="margin:3rem 0"></div>
        <h2 style="color:white">New to workd?</h2>
        <div style="color:#9bb6dc;font-size:1.6rem">
          Join with talents who found their next career boost with
          <b style="color:white">workd</b>.
        </div>
        <!-- <div
          class="capsule-button horizontal-center"
          @click="goToSignUp"
          id="btn-sgn-up-cn"
        >Sign up now</div>-->
      </div>
    </div>
    <div class="right-side vertical-center">
      <div style="position: absolute; top: 0; right: 0">
        <v-icon @click="goToLanding" size="50" color="grey">mdi-close</v-icon>
      </div>
      <div class="vertical-center" style="align-items:center">
        <v-tabs fixed-tabs v-model="tab" grow style="text-decoration:none" v-if="showTab">
          <v-tab id="LOG_IN_TAB_BUTTON" @click="login=true" key="1" style="text-decoration:none;font-size:1.4rem">
            <font :class="{select:login}" style="text-decoration:none">Log In</font>
          </v-tab>
          <v-tab id="SIGN_UP_TAB_BUTTON" @click="login=false" key="2" style="text-decoration:none;font-size:1.4rem">
            <font :class="{select:!login}" style="text-decoration:none">Create Account</font>
          </v-tab>
        </v-tabs>
        <div class="gap"></div>
        <login v-if="login" @clicked="handleClick"
               v-bind:job_id="job_id"
               v-bind:search_key="search_key"
        ></login>
        <sign-up v-else @clicked="handleClick" v-bind:job_id="job_id" v-bind:search_key="search_key"></sign-up>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "./login";
import SignUp from "./sign-up-component";
import { PHONE } from "../../globalFunctions";
export default {
  name: "sign-in",
  components: {
    Login,
    SignUp
  },
  data: function() {
    return {
      phone: PHONE(),
      login: true,
      tab: 0,
      showTab: true,
      job_id: null,
      search_key: null
    };
  },
  methods: {
    goToSignUp: function() {
      this.$router.push({ path: "signup" }).catch(function() {});
    },
    goToLanding: function() {
      this.$router.push({ name: "landingPage" }).catch(function() {});
    },
    handleClick(val) {
      this.showTab = !val;
    }
  },
  created() {
    if (this.$route.params) {
      if (!!this.$route.params.job_id) {
        this.job_id = this.$route.params.job_id;
      }
      if (!!this.$route.params.search_key) {
        this.search_key = this.$route.params.search_key;
      }
      if (this.$route.params.tab === 1) {
        this.tab = this.$route.params.tab;
        this.login = false;
      } else {
        this.tab = this.$route.params.tab;
        this.login = true;
      }
    } else {
      this.tab = 0;
      this.login = true;
    }
  }
};
</script>

<style scoped>
.signin-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
}
.left-side {
  height: 100vh;
  flex: 1;
  background-image: linear-gradient(to top, #001844, #294c8b);
}
.right-side {
  height: 100vh;
  flex: 1;
  background-image: url("../../assets/static_content/login-bg.svg");
  background-color: white;
  background-position: bottom;
}
.capsule-button {
  margin-top: 3.1rem;
  background-color: var(--landing-button-color);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.6rem;
  border-radius: 20rem;
  width: 15.6rem;
  height: 4rem;
  cursor: pointer;
}
.select {
  color: var(--landing-button-color);
}
.gap {
  height: 4rem;
  width: 100%;
}
@media (max-width: 600px) {
  .gap {
    height: 0px;
    width: 100%;
  }
}
</style>
